import React, { useState } from "react";
import "./ProductInfo.css";

const ProductInfo = ({ product }) => {
  const [selectedColor, setSelectedColor] = useState(
    product.colors && product.colors.length > 0 ? product.colors[0].id : ""
  );
  const [selectedSize, setSelectedSize] = useState("");

  if (!product) return null;

  const handleAddToCart = () => {
    if (!selectedSize) {
      alert("Please select a size first.");
      return;
    }
    alert(`Added ${product.brand} - ${selectedColor} - Size: ${selectedSize} to cart!`);
  };

  return (
    <div className="product-info-container">
      
      {/* Title */}
      <div className="pi-title-block">
        <h1 className="pi-title">
          <span className="pi-brand">{product.brand}</span>
          {product.fullTitle.replace(product.brand, "")}
        </h1>
        <div className="pi-sku">SKU: sw220815465</div>
      </div>

      {/* Rating */}
      <div className="pi-rating-block">
        <div className="pi-stars">★★★★★</div>
        <a href="#reviews" className="pi-reviews-link">(1000+ Reviews)</a>
      </div>

      {/* Price */}
      <div className="pi-price-block">
        <span className="pi-current-price">£{product.price.toFixed(2)}</span>
        <span className="pi-original-price">£{product.originalPrice.toFixed(2)}</span>
        <span className="pi-discount-badge">-{product.discount}%</span>
      </div>

      {/* Club */}
      {product.club && (
        <div className="pi-club-box">
          <span className="club-logo">S</span>
          <strong>{product.club.name}</strong> Save £{product.club.memberDiscount.toFixed(2)} off this item after joining.
          <span className="club-arrow">&gt;</span>
        </div>
      )}

      <div className="pi-special-deal">
        🚚 Special Free Shipping Deal
      </div>

      {/* Color */}
      <div className="pi-selector-section">
        <div className="selector-header">
          <strong>Color:</strong>
          <span>
            {product.colors?.find(c => c.id === selectedColor)?.name}
          </span>
        </div>

        <div className="pi-color-options">
          {product.colors?.map((color) => (
            <div
              key={color.id}
              className={`color-chip ${selectedColor === color.id ? "active" : ""}`}
              onClick={() => setSelectedColor(color.id)}
            >
              <img src={color.thumbnail} alt={color.name} />
              {(color.id === "c1" || color.id === "c5") && (
                <span className="hot-tag">HOT</span>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Size */}
      <div className="pi-selector-section">
        <div className="selector-header">
          <strong>Size</strong> <span>UK Size</span>
        </div>

        <div className="pi-size-options">
          {product.sizes?.map((size, index) => (
            <button
              key={index}
              className={`size-btn ${!size.available ? "disabled" : ""} ${
                selectedSize === size.label ? "active" : ""
              }`}
              disabled={!size.available}
              onClick={() => setSelectedSize(size.label)}
            >
              {size.label}
            </button>
          ))}
        </div>

        {/* ✅ FIXED (NO WARNING NOW) */}
        <button className="find-size-link">
          Not your size? Tell me your size &gt;
        </button>
      </div>

      {/* Actions */}
      <div className="pi-actions">
        <button className="pi-add-btn" onClick={handleAddToCart}>
          ADD TO CART
        </button>
        <button className="pi-wishlist-btn">♡</button>
      </div>

      <div className="pi-points">
        Earn up to <strong>15</strong> SHEIN Points calculated at checkout.
      </div>

      {/* Shipping */}
      <div className="pi-shipping-box">
        <h3>
          Shipping to <span>{product.shipping?.region || "United Kingdom"}</span>
        </h3>

        <div className="shipping-item">
          <div className="icon-side">🚚</div>
          <div className="content-side">
            <strong>Free Shipping</strong>
            <p className="est-delivery">
              Est. Delivery: {product.shipping?.estimatedDelivery?.from} - {product.shipping?.estimatedDelivery?.to}
            </p>
          </div>
          <div className="arrow-side">&gt;</div>
        </div>

        <div className="shipping-item">
          <div className="icon-side">📦</div>
          <div className="content-side">
            <strong>Return Policy</strong>
          </div>
          <div className="arrow-side">&gt;</div>
        </div>
      </div>

      {/* Accordion */}
      <div className="pi-accordions">
        <div className="accordion-item">
          <strong>Description</strong>
          <span>+</span>
        </div>

        <div className="accordion-item">
          <strong>Size & Fit</strong>
          <span>-</span>
        </div>

        <div className="accordion-content">
          <div className="model-info">
            <div className="model-avatar"></div>
            <div>
              <strong>Model is Wearing: {product.model.wearing}</strong>
              <p>
                Height: {product.model.height} Bust: {product.model.bust} Waist: {product.model.waist} Hips: {product.model.hips}
              </p>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default ProductInfo;